import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Registration.css";
import { Link } from "react-router-dom";

const Login = () => {
  
  return (
    <>
 <div className="d-flex justify-content-center align-items-center vh-100 bg-gradient">
      <div className="cards p-4 shadow-lg rounded-4" style={{ width: "500px" }}>
        <div className="text-center">
          <h2 className="fw-bold login">Login</h2>
        </div>
        
        <form className="p-2" >
          <div className="mb-3">
            <label className="form-label fw-semibold">User Name</label>
            <input type="text" name="given_name" className="form-control" placeholder="" required />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input type="email" name="email_address" className="form-control" placeholder="" required  />
          </div>
          <button type="submit" className="btn w-100 btn-sm btn-primary fw-bold ">Login</button>
        </form>
        <div className="text-center mt-3">
          <p className="text-muted">
            Don't have an account? <Link to="/Registration" className="text-primary">Sign Up</Link>
          </p>
        </div>

      </div>
    </div>

    
    </>
  )
}
export default Login;